export const getBaseApiUrl = () => {
  return process.env.LOCAL_BASE_API_URL || '/api';
};
